module.exports = __webpack_public_path__ + "assets/images/typeofcar-02.763b9545c067d3d881bbfa4bc578bbe1.svg";